<form [formGroup]="dadProductPriceForm" class="popup-form">

  <div class="popup-body">

    <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <div class="price-context">
      <span class="context-label">Product</span>
      <span class="context-value">{{ dadProductPriceForm.get('productCode').value || '-' }}</span>
      <span class="context-separator">·</span>
      <span class="context-label">Type</span>
      <span class="context-value">{{ dadProductPriceForm.get('productType').value || '-' }}</span>
    </div>

    <div class="field-row">
      <div class="field-group">
        <label for="amount">MRC amount</label>
        <input class="form-control" formControlName="amount" id="amount"
               placeholder="0" type="number" min="0">
        <span class="field-error"
              *ngIf="dadProductPriceForm.get('amount').touched && dadProductPriceForm.get('amount').errors">
          Required.
        </span>
      </div>

      <div class="field-group">
        <label for="currency">Currency</label>
        <p-dropdown [options]="currenciesList" [style]="{width: '100%'}"
                    formControlName="currency" id="currency"></p-dropdown>
      </div>
    </div>

    <div class="field-group">
      <label for="startDate">Valid from</label>
      <p-calendar formControlName="startDate" dateFormat="dd/mm/yy" id="startDate"
                  [style]="{width: '100%'}" appendTo="body"
                  panelStyleClass="sym-datepicker sym-datepicker-sm"></p-calendar>
    </div>

  </div>

  <div class="popup-footer">
    <button (click)="addDadProductPrice()" class="btn btn-primary"
            [disabled]="dadProductPriceForm.invalid">
      <i class="fa fa-plus-circle"></i> Add Price
    </button>
  </div>

</form>
